import React, { useState, useEffect } from 'react';
import Axios from "axios";
import { Grid, Typography, CircularProgress, Container, Box, Button, Card, CardContent, CardActionArea, Avatar } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import defaultProfilePicture from "../../Assets/defaultProfilePicture.jpg";

function ProducerList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [producers, setProducers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { config, environment } = require('../../index');

  useEffect(() => {
    const source = Axios.CancelToken.source();
    async function fetchProducers() {
      try {
        // Fetch users who have own produce items. 
        // For simplicity, we can fetch all profiles and filter, or a specialized endpoint.
        // Let's use companiesEndpoint which points to profiles.
        const response = await Axios.get(config[environment].companiesEndpoint, { cancelToken: source.token });
        // In a real app, you might want to filter only those who are actually producers
        setProducers(response.data);
        setLoading(false);
      } catch (error) {
        if (!Axios.isCancel(error)) {
          console.error("Error fetching producers:", error);
          setLoading(false);
        }
      }
    }
    fetchProducers();
    return () => source.cancel();
  }, [config, environment]);

  if (loading) {
    return (
      <Grid container justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4, mt: '50px' }}>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" sx={{ color: 'var(--sznodarkblue)', fontWeight: 'bold' }}>
          {t('Market.Producers', 'Helyi termelők')}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="contained" onClick={() => navigate('/sajat-termeny-hozzaadasa')} sx={{ bgcolor: 'green' }}>
                {t('Accommodation.RegisterAsProducer', 'Jelentkezés helyi termelőként')}
            </Button>
            <Button variant="contained" onClick={() => navigate('/market')}>
                {t('Common.Back')}
            </Button>
        </Box>
      </Box>
      <Grid container spacing={3}>
        {producers.length === 0 ? (
          <Typography variant="h6" sx={{ mt: 4, width: '100%', textAlign: 'center' }}>
            {t('Market.NoProducers', 'Jelenleg nincsenek regisztrált termelők.')}
          </Typography>
        ) : (
          producers.map((producer) => (
            <Grid item xs={12} sm={6} md={4} key={producer.seller}>
              <Card sx={{ height: '100%' }}>
                <CardActionArea onClick={() => navigate(`/termelo/${producer.seller}`)}>
                  <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Avatar 
                      src={producer.profile_picture || defaultProfilePicture} 
                      sx={{ width: 100, height: 100, mb: 2, border: '2px solid #105b79' }}
                    />
                    <Typography variant="h6" align="center" sx={{ fontWeight: 'bold' }}>
                      {producer.company_name || producer.seller_username}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                      {producer.bio ? producer.bio.substring(0, 100) + '...' : ''}
                    </Typography>
                  </Box>
                </CardActionArea>
              </Card>
            </Grid>
          ))
        )}
      </Grid>
    </Container>
  );
}

export default ProducerList;
